/**
 * Hook: Add/Edit facility modal state for Cleaning Standards page.
 * Single Responsibility: open/close and selected facility for add vs edit modal.
 */

import { useState, useCallback } from 'react';

export function useCleaningStandardsModals() {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [facilityToEdit, setFacilityToEdit] = useState(null);

  const openAddModal = useCallback(() => {
    setIsAddModalOpen(true);
  }, []);

  const closeAddModal = useCallback(() => {
    setIsAddModalOpen(false);
  }, []);

  const openEditModal = useCallback((facility) => {
    setFacilityToEdit(facility);
    setIsEditModalOpen(true);
  }, []);

  const closeEditModal = useCallback(() => {
    setIsEditModalOpen(false);
    setFacilityToEdit(null);
  }, []);

  return {
    isAddModalOpen,
    isEditModalOpen,
    facilityToEdit,
    openAddModal,
    closeAddModal,
    openEditModal,
    closeEditModal,
  };
}
